import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import centralized filter config

const D01BarChartViz05 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const demcat05Order = [
      "Less than 1 year",
      "1 to 2 years",
      "3 to 5 years",
      "6 to 10 years",
      "11 to 19 years",
      "20 years or more",
    ];

    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by demcat05 (demographic_category_05 in the new JSON)
    const demcat05Counts = filteredData.reduce((acc, item) => {
      const demcat05 = item.demographic_category_05; // Use demographic_category_05 for demcat05
      if (!acc[demcat05]) {
        acc[demcat05] = 0;
      }
      acc[demcat05]++;
      return acc;
    }, {});

    // Sort the demcat05s according to `demcat05Order`
    const sorteddemcat05Data = demcat05Order.map((demcat05) => ({
      demcat05,
      count: demcat05Counts[demcat05] || 0,
    }));

    const demcat05Names = sorteddemcat05Data.map((item) => item.demcat05);
    const chartData = sorteddemcat05Data.map((item) => item.count);

    // Update state
    setCategories(demcat05Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25;
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * demcat05Names.length,
      barHeight * minBars
    );

    // Chart options
    const optionsViz05 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight,
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 20, // Move labels off the bars
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat05Names,
      },
    };

    // Render the chart
    const viz05 = new ApexCharts(
      document.querySelector("#viz-05"),
      optionsViz05
    );
    viz05.render();

    // Cleanup chart on component unmount
    return () => {
      viz05.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto" }}>
      <div id="viz-05"></div>
    </div>
  );
};

export default D01BarChartViz05;
